export default __webpack_public_path__ + "44861a3c5c05ec3d2e652477e23aed96.svg";